import communityWalkthrough from '../../modules/community/walkthrough/nso.json';

export const NSO = {
  translation: {
    ...communityWalkthrough,
  },
};
